import { HttpContextToken } from '@angular/common/http';

/**
 * When true, the auth interceptor skips refresh-and-retry for the request.
 * Set this on the refresh request itself and on all retried requests to
 * prevent infinite loops.
 */
export const SKIP_AUTH_RETRY = new HttpContextToken<boolean>(() => false);
